import AdvanteIcons from "../AdvanteIcons"; 
import roboHandsHeader from "../../images/motionode/ai-builder-pr.png"

const Header = () => {
    return (
        <section className='ai-header' >
          
            <div className="bgr-noise"></div>

            <div className="blur-circle circle-ai circle-pink circle-ai-pink-1"></div>
            <div className="blur-circle circle-ai circle-violet circle-ai-violet-1"></div>
            <div className="blur-circle circle-ai circle-pink circle-ai-pink-2"></div>
            <div className="blur-circle circle-ai circle-violet circle-ai-violet-2"></div>
            <div className="blur-circle circle-ai circle-violet circle-ai-violet-3"></div>

            <div className="ai-header-wrapper">

                <div className="ai-header-icon">
                    <AdvanteIcons 
                        type="IcoArtificialIntelligence" 
                        fill="var(--orchid-pink)"
                    />
                </div>

                <div className="ai-header-box">
                    <h2>AI implementation for <span className="text-pink-blue-violet">real software operations</span>.</h2>

                    <div className="ai-header-copy">
                        <p>We help companies apply AI where it actually improves operations: software delivery, internal workflows, support processes, data handling, document review, reporting, and product features. Our own delivery process is powered by Motionode, giving our team an AI-assisted but controlled way to manage tickets, code changes, reviews, QA, and deployment.</p>
                    </div>
                </div>

                <div className="robohand-header">
                    <img src={ roboHandsHeader } alt="Motionode AI Builder assisting software delivery" loading="lazy" />
                </div>
            
            </div>
                
           
        </section>
    );
  }
  
  export default Header;